import { createSlice } from '@reduxjs/toolkit';

export const drawerSlice = createSlice({
  name: 'drawerSlice',
  initialState: {
    opened: false
  },
  reducers: {
    toggleDrawer(state) {
      return {
        ...state,
        opened: !state.opened
      };
    }
  }
});

export const { toggleDrawer } = drawerSlice.actions;

export default drawerSlice.reducer;
